var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-search"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.9999,
    cy: 6.41667,
    rx: 3.66667,
    ry: 3.66667,
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M5.5 19.25V17.4167C5.5 15.3916 7.14162 13.75 9.16667 13.75H10.0833",
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_2",
    cx: 15.1249,
    cy: 16.0417,
    rx: 2.29167,
    ry: 2.29167,
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M16.9583 17.875L19.2499 20.1667",
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSearch);
export default __webpack_public_path__ + "static/media/user-search.e3ac7f7a6cf62b2414958097bbe9682f.svg";
export { ForwardRef as ReactComponent };